module.exports = __APP_CONFIG__;